import { Stack, styled } from "@mui/material";

export const TransactionPostingWrapper = styled(Stack)(({ theme }) => {
    return {
        gap: "var(--flex-gap)",
        padding: "var(--basic-padding)",
        backgroundColor: "var(--light-color)",
        borderRadius: "16px",
        overflow: "hidden",
        "& form": {
            display: "flex",
            flexDirection: "column",
            gap: "var(--flex-gap)",
            flex: 0.6,
        },
        "& fieldset": {
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
        },
        "& .MuiCard-root": {
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
        },
        "& .card-content": {
            padding: "0",
            display: "flex",
            flexDirection: "column",
            height: "100%",
        },
        "& .card-content:last-child": {
            paddingBottom: 0,
        },
    }
});